var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3749 7.21521V24.7845C30.3749 26.1073 29.3017 27.1804 27.9791 27.1804H4.02081C2.69813 27.1804 1.625 26.1073 1.625 24.7845V7.21521C1.625 5.89246 2.69813 4.81934 4.02081 4.81934H27.9791C29.3017 4.81934 30.3749 5.89252 30.3749 7.21521Z",
    fill: "#0353A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3616 12.0068H24.8093C24.3302 12.0068 23.9657 12.1466 23.7611 12.6507L20.7812 19.7632H22.8876C22.8876 19.7632 23.2321 18.805 23.3069 18.6003H25.8824C25.9422 18.8748 26.1219 19.7632 26.1219 19.7632H27.9788L26.3616 12.0068ZM23.8859 17.0131C24.0507 16.569 24.6845 14.842 24.6845 14.842C24.6745 14.8569 24.8492 14.3877 24.9491 14.0982L25.0887 14.7671C25.0887 14.7671 25.4681 16.6238 25.553 17.0131H23.8859V17.0131Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2699 12.0068L8.30836 17.2976L8.09367 16.2245L7.39486 12.6606C7.28004 12.1665 6.92567 12.0268 6.48642 12.0068H3.25717L3.22217 12.1616C4.01079 12.3613 4.71461 12.6508 5.32848 13.0151L7.11542 19.7534H9.23667L12.3911 12.0069H10.2699V12.0068Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1996 12.0068L11.9468 19.7633H13.9484L15.2062 12.0068H13.1996Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2491 15.1163C18.5454 14.7619 18.1161 14.5223 18.1161 14.1579C18.126 13.8285 18.4804 13.4891 19.2691 13.4891C19.9229 13.4741 20.4021 13.6289 20.7614 13.7835L20.9412 13.8684L21.2157 12.1913C20.8213 12.0365 20.1925 11.8618 19.4188 11.8618C17.4373 11.8618 16.0447 12.9201 16.0347 14.4274C16.0197 15.5404 17.0329 16.1594 17.7916 16.5337C18.5653 16.9129 18.8298 17.1626 18.8298 17.497C18.8199 18.0162 18.2009 18.2558 17.6269 18.2558C16.8283 18.2558 16.399 18.1309 15.7453 17.8416L15.4807 17.7166L15.2012 19.4586C15.6702 19.6733 16.5388 19.8629 17.4372 19.873C19.5435 19.8779 20.9162 18.8346 20.9311 17.2275C20.9412 16.3441 20.4022 15.6703 19.2491 15.1163Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.1ab3515c569c6a8ae6d5ee2318d8e388.svg";
export { ForwardRef as ReactComponent };